import { render } from "./SalesSearchFilters.vue?vue&type=template&id=6d58d137"
import script from "./SalesSearchFilters.vue?vue&type=script&lang=js"
export * from "./SalesSearchFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__